import React from "react";
import styled from "styled-components";
import GlobalStyle from "../../../GlobalStyle";
import SendIcon from "../../../assets/img/CuratedContent/Send.svg";

const ButtonLeftIcon = (props) => {
  const { label, icon, green } = props;
  return (
    <>
      <GlobalStyle />
      <Btn green={green} {...props}>
        <span className="icon">
          {green ? <img src={icon} alt="icon" /> : <img src={icon} alt="icon" />}
          {/* <object type="image/svg+xml" data={icon}></object> */}
        </span>
        <span className="label">{label}</span>
      </Btn>
    </>
  );
};

ButtonLeftIcon.defaultProps = {
  label: "Curation History",
};

export default ButtonLeftIcon;

const Btn = styled.button`
  &:hover {
    background-color: #27ce0a;
    color: #fff;
    span.icon {
      filter: invert(0) sepia(0) saturate(1) hue-rotate(0deg) brightness(5);
    }
  }
  border-radius: 8px;
  background-color: ${(props) => (props.green ? "#27CE0A" : "#fff")};
  color: ${(props) => (props.green ? "#fff" : "#7E7E7E")};
  font-size: 16px;
  font-weight: 500;
  padding: 0 8px;
  line-height: 20px;
  border: solid 1px #dadada;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "robotomedium";
  margin-top: 3px;
  letter-spacing: -0.4px;
  width: 100%;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 6px;
    font-size: 12px;
  }
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
  }
  span.label {
    padding: 2px 0;
    float: left;
  }
  span.icon {
    display: flex;
    padding: 1px 1px;
    margin: 8px 0px;
    float: left;
    svg {
      float: left;
      height: 20px;
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 15px;
      }
    }
    img {
      height: 20px;
      width: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 15px;
      }
    }
  }
`;
